const SERP_OPEN_SOURCE = {
  DEEP_LINK: 'deep_link',
  HOT_OFFERS: 'hot_offers',
  SPECIAL_OFFERS: 'special_offers',
  MAIN_PAGE: 'main_page',
  CALENDAR_PRICE: 'price_calendar',
  SHARED_LINK: 'shared_link',
  SEARCH_PAGE: 'search_page',
  LAST_SEARCHES: 'last_searches',
  FAVORITES: 'favorites',
  RECOMMENDED_OFFERS: 'recommended_offers',
} as const;

const DETAILS_PAGE_OPEN_SOURCE = {
  ...SERP_OPEN_SOURCE,
  DIRECT_FLIGHTS: 'direct_flights',
} as const;

export const amplitudeEventsConfig = {
  SERP_OPEN_SOURCE,
  DETAILS_PAGE_OPEN_SOURCE,
};

export * as amplitudeEventsConfigTypes from './types';
